export default "__VITE_ASSET__B_LDd2wC__"